import axios from 'axios';

import { responseEntityMapper } from '@qwealth/qcore';

import { REACT_APP_QWEALTH_API, errorHandler } from 'services/axiosService';
import { AppThunkDispatch } from 'data/store';
import { FeatureFlag, FeatureFlagResponse } from 'data/models/featureFlag'

export const checkFeatureFlag = (flagName: FeatureFlag, iaCode?: string) => async (dispatch: AppThunkDispatch): Promise<FeatureFlagResponse> => {
  const params = iaCode ? {iaCode} : undefined;
  return axios
    .get(`${REACT_APP_QWEALTH_API}/featureFlag/${flagName}`, {params})
    .then((response) => responseEntityMapper<FeatureFlagResponse>(response))
    .catch((e) => errorHandler(dispatch, 'API Error: Failed retrieving feature flag')(e));
};